import { GalleryResource, ImageAsset } from "../.."
import { ErrorCallback, fetchGet } from "../common/Requests"
import { Gallery } from "../gallery/Gallery"
import ProfileResource from "./ProfileResource"

export class Profile {
  username: string
  displayName: string
  public: boolean
  company: string | null
  website: string | null
  description: string | null
  numberOfUploads: number
  industry: string | null
  avatar: ImageAsset | null
  coverImage: ImageAsset | null
  createdAt: Date
  actionButton: {
    type: string
    url: URL
  } | null
  links: {
    galleries: string
  }

  constructor() {
    this.username = ""
    this.displayName = ""
    this.company = null
    this.website = null
    this.description = null
    this.numberOfUploads = 0
    this.industry = null
    this.avatar = null
    this.coverImage = null
    this.createdAt = new Date()
    this.actionButton = null
    this.links = {
      galleries: ""
    }
  }

  static fromResource(resource: ProfileResource): Profile {
    let profile = new Profile()
    profile.username = resource.username
    profile.displayName = resource.displayName
    profile.public = resource.public
    profile.company = resource.company
    profile.website = resource.website
    profile.description = resource.description
    profile.numberOfUploads = resource.numberOfUploads
    profile.industry = resource.industry
    profile.avatar = resource.avatar
    profile.coverImage = resource.coverImage
    profile.createdAt = new Date(resource.createdAt)

    if (resource.actionButton.type && resource.actionButton.url) {
      try {
        profile.actionButton = {
          type: resource.actionButton.type,
          url: new URL(resource.actionButton.url)
        }
      } catch (e) {
        console.error(e)
      }
    }

    profile.links = {
      galleries: resource._links.galleries.href
    }

    return profile
  }

  fetchPublicGalleries(link: string | null, handleSuccess: (galleries: Gallery[], nextLink: string | null) => void, handleError: ErrorCallback) {
    fetchGet(
      link ?? this.links.galleries,
      (json) => {
        let resources = json._embedded.galleries as GalleryResource[]
        let galleries = resources.map(resource => Gallery.fromResource(resource))
        handleSuccess(
          galleries,
          json._links.next?.href ?? null
        )
      },
      handleError
    )
  }
}
